/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Environmenttype1Inputs */

const en_entity_environmenttype1 = /** @type {(inputs: Entity_Environmenttype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Environment Type`)
};

const de_entity_environmenttype1 = /** @type {(inputs: Entity_Environmenttype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umgebungstyp`)
};

/**
* | output |
* | --- |
* | "Environment Type" |
*
* @param {Entity_Environmenttype1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_environmenttype1 = /** @type {((inputs?: Entity_Environmenttype1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Environmenttype1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_environmenttype1(inputs)
	return de_entity_environmenttype1(inputs)
});
export { entity_environmenttype1 as "entity_environmentType" }